import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { RouteDictionary, RouteInfo } from 'components/Models/routeTypes'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { getAllRouteInfoFromPath } from 'components/Utilities/routeUtils'
import BreadcrumbItem from './BreadcrumbItem'

const useStyles = makeStyles((theme: Theme) => ({
    breadcrumbRoot: {
        ...theme.typography.h1,
        '& .MuiBreadcrumbs-separator': {
            color: '#000',
        },
    },
}))

const AppBreadcrumbs: React.FC<{ routes: RouteDictionary }> = ({
    routes = {},
}) => {
    const classes = useStyles()
    const { pathname } = useLocation()
    const trail: RouteInfo[] = getAllRouteInfoFromPath(pathname, routes)

    return (
        <Breadcrumbs
            className={classes.breadcrumbRoot}
            data-testid="appBreadcrumbs"
        >
            {trail.map((routeItem) => {
                return (
                    <BreadcrumbItem
                        key={routeItem.path ?? ''}
                        title={routeItem.name ?? ''}
                        path={
                            pathname === routeItem.path
                                ? undefined
                                : routeItem.path ?? ''
                        }
                    />
                )
            })}
        </Breadcrumbs>
    )
}

export default AppBreadcrumbs
